import { useEffect } from "react";

const simplifyQualificationForm = () => {
  document.querySelectorAll<HTMLElement>(".modal").forEach(modal => {
    const heading = [...modal.querySelectorAll("h2")].find(h => h.textContent?.toLowerCase().includes("qualification"));
    if (!heading) return;

    modal.querySelectorAll<HTMLElement>(".rule-preview").forEach(preview => {
      if (preview.style.display !== "none") preview.style.display = "none";
    });

    modal.querySelectorAll<HTMLSelectElement>("select").forEach(select => {
      const label = select.closest("label")?.textContent?.toLowerCase() || "";
      if (!label.includes("qualification category")) return;

      const annexM = Boolean(select.closest(".personnel-fields")?.textContent?.includes("ANNEX M"));
      [...select.options].forEach(option => {
        let next = "";
        if (option.value === "S") next = annexM ? "S-M · S Classification" : "S Classification";
        if (option.value === "T_PLATE") next = annexM ? "T-M · T Classification · Plate" : "T Classification · Plate";
        if (option.value === "T_PIPE") next = annexM ? "T-M · T Classification · Pipe" : "T Classification · Pipe";
        if (next && option.text !== next) option.text = next;
      });
    });
  });
};

export default function QualificationFormSimplifier() {
  useEffect(() => {
    simplifyQualificationForm();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        simplifyQualificationForm();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
  return null;
}
